import { actaApi } from './actaApi';
import { DashboardPublicationsResponse } from '../types/dashboard';

/**
 * Obtém os dados de publicações da dashboard, filtradas por entity_id.
 */
export async function getPublicationsDashboard(
  entityId: string
): Promise<DashboardPublicationsResponse> {
  // Ex.: /dashboard?entity_id=123
  const response = await actaApi.get<DashboardPublicationsResponse>(
    `/dashboard?entity_id=${entityId}`
  );
  return response.data;
}
